import React, { useState, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import htmlEditButton from "quill-html-edit-button";

// Register html edit button with Quill
Quill.register("modules/htmlEditButton", htmlEditButton);

const MultiHtmlContent = ({
  contentObject = {},
  onContentChange = () => {},
  isDisable = false,
}) => {
  // Get all platform keys dynamically
  const platforms = Object.keys(contentObject).filter(
    (key) => contentObject[key]?.PostHTML
  );

  const [selectedPlatform, setSelectedPlatform] = useState(platforms[0] || "");
  const [localContent, setLocalContent] = useState(contentObject);

  // Keep localContent in sync when parent changes it
  useEffect(() => {
    setLocalContent(contentObject);
  }, []);

  // Handle platform change
  const handlePlatformChange = (platform) => {
    setSelectedPlatform(platform);
  };

  // Handle title change
  const handleTitleChange = (value) => {
    const updated = {
      ...localContent,
      [selectedPlatform]: {
        ...localContent[selectedPlatform],
        TitleHTML: value,
      },
    };
    setLocalContent(updated);
    onContentChange(updated); // return whole object
  };

  // Handle post change
  const handleEditorChange = (content) => {
    const updated = {
      ...localContent,
      [selectedPlatform]: {
        ...localContent[selectedPlatform],
        PostHTML: content,
      },
    };
    setLocalContent(updated);
   
    onContentChange(updated); // return whole object
  };

  // Quill modules with html edit button
  const quillModules = {
    toolbar: [["htmlEditButton"]],
    htmlEditButton: {
      debug: true,
      msg: "Edit the content in HTML format",
      okText: "Ok",
      cancelText: "Cancel",
      buttonHTML: '<button class="ql-html-edit-btn">Edit Html</button>', // ✅ full button
      buttonTitle: "Show HTML source",
    },
  };

  const quillModulesDisabled = { toolbar: [] };

  return (
    <div>
      {/* Toolbar Fix */}
      <style>{`
        .ql-toolbar .ql-formats:has(.ql-html-edit-btn) {
          display: block;
          width: 100%;
        }

        .ql-snow.ql-toolbar button,
        .ql-snow .ql-toolbar button {
          display: block;
          width: 100% !important;
          padding: 0;
          border: none;
          background: transparent;
        }

        .ql-toolbar .ql-html-edit-btn {
          display: block;
          width: 100%;
          text-align: center;
          background: white;
          border: 1px solid #ccc;
          border-radius: 4px;
          padding: 6px 10px;
          font-size: 13px;
          cursor: pointer;
          margin-top: 4px;
        }

        .ql-toolbar .ql-html-edit-btn {
          background: #f5f5f5 !important;
        }
      `}</style>

      {/* Platform Selector */}
      {platforms.length > 0 && (
        <div style={{ marginBottom: "1rem" }}>
          <label
            htmlFor="platform-select"
            style={{ marginRight: "0.5rem", color: "white" }}
          >
            Choose Platform:
          </label>
          <select
            id="platform-select"
            value={selectedPlatform}
            onChange={(e) => handlePlatformChange(e.target.value)}
          >
            {platforms.map((platform) => (
              <option key={platform} value={platform}>
                {platform.charAt(0).toUpperCase() + platform.slice(1)}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Editable Title */}
      {localContent[selectedPlatform]?.TitleHTML && (
        <ReactQuill
          readOnly={isDisable}
          theme="snow"
          value={localContent[selectedPlatform].TitleHTML}
          onChange={handleTitleChange}
          modules={isDisable ? quillModulesDisabled : quillModules}
          style={{ marginBottom: "1rem", color: "white" }}
        />
      )}

      {/* Editable Post */}
      {selectedPlatform && (
        <ReactQuill
          readOnly={isDisable}
          theme="snow"
          value={localContent[selectedPlatform]?.PostHTML || ""}
          onChange={handleEditorChange}
          modules={isDisable ? quillModulesDisabled : quillModules}
          style={{ marginBottom: "1rem", color: "white" }}
        />
      )}
    </div>
  );
};

export default MultiHtmlContent;
